import { isPipelineInFlight } from "@/features/stash/saveActivity";

/**
 * Utility functions for checking post state (pending/enrichment)
 */

export interface PostWithState {
  title?: string;
  enrichment_status?: string;
  unfurl_status?: string;
  pipeline?: Record<string, unknown>;
  needs_enrichment?: boolean;
  created_at?: string;
}

/**
 * Check if a post has restricted content (age-gated or private account).
 * These posts are done processing — they should NOT appear as pending.
 */
export const isPostRestricted = (post: PostWithState): boolean => {
  return post.unfurl_status === "age_restricted"
    || post.unfurl_status === "private"
    || post.unfurl_status === "empty";
};

/**
 * Whether the pipeline is still working on this post. The pipeline's own
 * status is the only signal — see features/stash/saveActivity.
 */
export const isPostPending = (post: PostWithState): boolean => isPipelineInFlight(post, Date.now());
